import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';

@Component({
  selector: 'app-card-table-action',
  template: `@if (!makeToggle && (display == true || display == null)) {
    <span class="action" (click)="clicked()" [ngClass]="{ 'action-card': layoutService.screenSize <= breakpoint }">
      @if (showIcon) {
      <mat-icon [className]="iconName" [color]="color"><img class="icon-image" src="{{ iconSrc }}" /></mat-icon>
      }
      <mat-label color="color">{{ title }}</mat-label>
    </span>
    } @if (!makeToggle && display == false) {
    <span class="action" style="visibility: hidden" (click)="(null)" [ngClass]="{ 'action-card': layoutService.screenSize <= breakpoint }">
      @if (showIcon) {
      <mat-icon [className]="iconName" [color]="color"><img class="icon-image" src="{{ iconSrc }}" /></mat-icon>
      }
      <mat-label color="color">{{ title }}</mat-label>
    </span>
    } @if (makeToggle) {
    <span class="action" (click)="toggled($event)" [ngClass]="{ 'action-card': layoutService.screenSize <= breakpoint }">
      <mat-slide-toggle [checked]="subCustomersToggled"></mat-slide-toggle>
      <mat-label color="color">{{ title }}</mat-label>
    </span>
    } @if (makeCheckbox) {
    <span class="action" (click)="checked($event)" [ngClass]="{ 'action-card': layoutService.screenSize <= breakpoint }">
      <mat-checkbox [checked]="valueChecked" class="mat-margin-none"></mat-checkbox>
    </span>
    }`,
  styles: [
    `
      .action {
        display: flex;
        margin: 0px 5px 0 5px;
        align-items: center;
        color: var(--ion-color-medium);
        /* padding: 5px; */
      }

      .action:hover {
        cursor: pointer;
      }

      .action-card mat-icon {
        display: none;
      }

      .action-card mat-label {
        color: var(--ion-color-medium);
      }

      .icon-image {
        color: #08074b;
      }

      mat-icon {
        width: 18px;
        font-size: 18px;
        margin: 3px;
        color: #08074b;
      }
    `,
  ],
})
export class CardTableActionComponent {
  @Input() iconName: string;
  @Input() iconSrc: string;
  @Input() color: string;
  @Input() title: string;
  @Input() showIcon: boolean;
  @Input() breakpoint: ScreenSize;
  @Input() makeToggle: boolean;
  @Input() makeCheckbox: boolean;
  @Input() valueChecked: boolean;
  @Input() subCustomersToggled: boolean;
  @Input() clickable: boolean;
  @Input() display: boolean;

  @Output() clickedEvent = new EventEmitter();
  @Output() toggledEvent = new EventEmitter();
  @Output() checkedEvent = new EventEmitter();

  constructor(public layoutService: LayoutService) {}

  clicked(): void {
    this.clickedEvent.emit(this.title);
  }

  toggled(ev: any): void {
    this.toggledEvent.emit(ev.target.checked);
  }

  checked(ev: any): void {
    this.checkedEvent.emit(ev.target.checked);
  }
}
